import { Flex, Text } from '@spotify-internal/encore-web';
import { extractLastNameComponent } from '@spotify/confidence-core-react';
import { AttachmentFragment } from '@spotify/confidence-graphql';

import { PreviewShell } from './components';

interface DefaultResourcePreviewProps {
  artifact: AttachmentFragment;
  label: string;
}

export const DefaultResourcePreview = ({
  artifact,
  label,
}: DefaultResourcePreviewProps) => (
  <PreviewShell>
    <Flex direction="column" gap="tighter-4">
      <Text variant="bodyMediumBold">
        {artifact.displayName || extractLastNameComponent(artifact.uri)}
      </Text>
      <Text variant="bodySmall" semanticColor="textSubdued">
        {label}
      </Text>
    </Flex>
  </PreviewShell>
);
